<template>
    <div ref="parent" class="pe" :data-required="required">
        <!-- {{instance}} -->
        <div v-if="instance.title || instance.content" class="pe__top v--15">
            <h2 v-if="instance.title" v-html="instance.title" class="pe__title type--h2"></h2>
            <div class="pe__content type--content-links type--content-margins type--content-styles"
                v-html="instance.content"></div>
        </div>
        <div class="pe__members pe__members--audio" ref="members">
            <div v-for="(video, index) in instance.videos" :key="index" class="pe__member r"
                :data-member-name="video.title" data-watched="false" :data-id="index">

                <div class="pe__member__link r v--5" :data-video="video.embed_url">
                    <div v-if="video.display_title || video.description" class="vt_member__details r v--5">
                        <p v-if="video.display_title"><strong>{{ video.display_title }}</strong></p>
                        <p v-if="video.description" v-html="video.description"></p>
                    </div>

                    <EmbedPlayer :activeVideo="activeVideo" :id="index" :appState="appState" :instance="instance" :videoInfo="video" :pauseVideo="pauseVideo" :active="active" @playingVideo="videoIsPlaying"></EmbedPlayer>
                </div>

            </div>
        </div>
        <div v-if="instance.hide_button !== true"
            class="pe__footer r r--justify-center r--halign-center v--30 type--align-center">
            <transition name="button">
                <button v-if="!isLast" :disabled="!is_valid" class="ms__next btn btn--solid" @click="$emit('next')">
                    Next
                </button>
                <button v-if="isLast" :disabled="!is_valid" class="btn btn--solid" @click="finish()">
                    Finish
                </button>
            </transition>
        </div>
    </div>
</template>

<script>
import Icon from "@c/Icon.vue";
import EmbedPlayer from "@c/EmbedPlayer.vue";

export default {
    components: {
        Icon,
        EmbedPlayer,
    },
    data() {
        return {
            watched: 0,
            //required: this.instance.required_count ? this.instance.required_count : 0,
            is_valid: false,
            imageSize: "full",
            activeVideo: null,
        }
    },
    computed: {
        required() {
            return this.instance.required_count ? parseInt(this.instance.required_count) : 0;
        },
    },
    watch: {
        pauseVideo() {
            if (this.pauseVideo === true) {
                console.log('panel audio pause watch true');
            }
        },
    },
    props: {
        instance: Object,
        siloData: Object,
        active: Boolean,
        pauseVideo: Boolean,
        appState: String,
        isLast: Boolean,
    },
    mounted() {
        this.reset();
        this.validate();
    },
    watch: {
        active() {
            if (this.active === true) {
                console.log('PANEL EMBEDS: Active');
                this.reset();
            } else {
                this.reset();
            }
        }
    },
    methods: {
        // validate watched count, this only counts for one watch at this time
        validate() {
            console.log('PANEL EMBEDS: Validating');
            if (this.watched >= this.required) {
                this.is_valid = true;
            } else {
                this.is_valud = false;
            }
        },
        reset() {
            this.watched = 0;
            this.is_valid = false;
            this.activeVideo = null;
        },
        finish() {
            this.reset();
            this.$emit('close');
        },
        videoIsPlaying(id) {
            console.log('EMBEDS PANEL: video is playing!');

            // Pause all other videos
            this.activeVideo = id;

            // Find parent of currently playing video
            let parent = this.$refs.parent.querySelector(`[data-id="${id}"]`);

            // Add some style to this specific one
            parent.dataset.watched = "true";

            // Increase watched count
            this.watched++;

            // validate to see if we can move on
            this.validate();
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@s/_mixins.scss";
@import "@s/_vars.scss";
.pe {
    display: flex;
    flex-direction: column;
    gap: rem(30px);
}
.pe__members {

    &--audio {
        display: flex;
        flex-direction: column;
        gap: rem(40px);

        .pe__member {
            max-width: inherit;

            audio {
                display: block;
                width: 100%;
                height: 60px !important;
            }
        }
    }
}

.pe__member[data-watched="true"] {
    iframe, audio {
        //opacity: 0.5 !important;
    }
}

[data-required="0"] {
    .pe__member[data-watched="true"] {
        iframe, audio {
            //opacity: 1 !important;
        }
    }
}

.pe__member__link {
    .embed__video {
        margin-top: rem(15px) !important;
    }
}
</style>